export const GET_DELIVERY_REQUEST = 'GET_DELIVERY_REQUEST';
export const SET_DELIVERY = 'SET_DELIVERY';

export const getDeliveryRequest = ({ destinationLat, destinationLng, onComplete }) => ({
  type: GET_DELIVERY_REQUEST,
  destinationLat,
  destinationLng,
  onComplete
});
